const STANDARD_STATUSES = new Set([
  "CLEARED",
  "CLEARED_WITH_WARNINGS",
  "NOT_CLEARED",
  "PENDING_CLEARANCE",
]);

const SUCCESS_STATUSES = new Set([
  "REPORTED",
  "REPORTED_WITH_WARNINGS",
  "CLEARED",
  "CLEARED_WITH_WARNINGS",
]);

const STATUS_LABELS = {
  PENDING_SIGNING: "Pending signing",
  SIGNING_FAILED: "Signing failed",
  ZATCA_CHAIN_WAIT: "Waiting for prior invoice",
  HELD: "Held for ZATCA downtime",
  SUBMITTING: "Submitting",
  ZATCA_RETRY_QUEUED: "Queued for retry",
  ZATCA_FAILED_MANUAL: "Needs manual review",
  MANUALLY_HANDLED: "Manually handled",
  REPORTED: "Reported",
  REPORTED_WITH_WARNINGS: "Reported with warnings",
  NOT_REPORTED: "Not reported",
  CLEARED: "Cleared",
  CLEARED_WITH_WARNINGS: "Cleared with warnings",
  NOT_CLEARED: "Not cleared",
  INTERNAL_ONLY: "Internal only",
};

export const isStandardZatcaDocument = (item) =>
  item?.invoice_type === 1 ||
  ([3, 4].includes(item?.invoice_type) && item?.parent_type === 1) ||
  STANDARD_STATUSES.has(String(item?.zatca_status || "").toUpperCase());

export const isInternalPurchaseDocument = (item) => {
  const purchase = item?.invoice_type === 2 ||
    (item?.invoice_type === 4 && item?.parent_type === 2);
  if (!purchase) return false;
  const status = String(item?.zatca_status || "").toUpperCase();
  if (status === "INTERNAL_ONLY") return true;
  // Preserve any historical submission result or signed document evidence.
  return !status && !item?.signed_xml_url && !item?.cleared_xml_url;
};

export const getZatcaStatusDisplay = (item) => {
  if (isInternalPurchaseDocument(item)) {
    return { label: "Internal purchase", success: null };
  }
  if (item?.onboarding !== 1) {
    return { label: "--", success: null };
  }

  const status = String(item?.zatca_status || "").toUpperCase();
  if (status && STATUS_LABELS[status]) {
    return {
      label: STATUS_LABELS[status],
      success: status === "INTERNAL_ONLY" ? null : SUCCESS_STATUSES.has(status),
    };
  }
  if (item?.signed_xml_url) {
    return {
      label: isStandardZatcaDocument(item) ? "Pending clearance" : "Pending reporting",
      success: false,
    };
  }
  return { label: "Not signed", success: false };
};
